import './app-loader.css';
import { BrandMark } from '../BrandMark.js';

interface AppLoaderProps {
  /**
   * Texto contextual opcional bajo el logo (ej. "armando tu camino" en
   * /progress). Sin `label` → sólo el logo (loader neutro del resto de la app).
   */
  label?: string;
  /**
   * `true` (default) → llena el alto disponible y centra (loader de pantalla).
   * `false` → inline compacto, para loaders embebidos en una sección.
   */
  fill?: boolean;
  /**
   * Loader de PANTALLA: se ancla al VIEWPORT (`position: fixed; inset: 0`,
   * pointer-events: none) → el orb queda SIEMPRE en el centro exacto, sin
   * importar cuánto chrome (header/tabs/filtros) tenga la pantalla ni qué
   * ancestros tengan position:relative. Usala para TODO loading primario de
   * pantalla; `fill`/`fill={false}` quedan para loaders embebidos en una
   * sección (con contenido real alrededor). Funciona anidado en cualquier
   * scroll container (el fixed lo saca del flujo: no genera scroll).
   */
  page?: boolean;
}

/**
 * AppLoader — el loader de marca ÚNICO de la app: el isologo de orborix speak
 * (la o que habla) con las ondas latiendo. Es idéntico en TODAS las pantallas
 * (auth splash, hold-and-reveal del home, /progress, biblioteca, …); lo único
 * que cambia es el `label` contextual. NO usar spinners sueltos por pantalla:
 * cualquier estado de carga primario debe renderizar este componente.
 */
export function AppLoader({ label, fill = true, page = false }: AppLoaderProps) {
  const cls = page
    ? 'app-loader app-loader--fill app-loader--page'
    : fill
      ? 'app-loader app-loader--fill'
      : 'app-loader';
  return (
    <div className={cls}>
      <BrandMark className="app-loader-mark" size={60} />
      {label != null && (
        <div className="app-loader-txt">
          {label}
          <span className="dots-anim" />
        </div>
      )}
    </div>
  );
}
